export default __webpack_public_path__ + "static/media/ERC_App_Icon_02.e78d525b.png";